/**
 * Tab mở từ TRƯỚC một lần deploy vẫn giữ index cũ, nên nó xin các chunk theo hash
 * cũ — server đã xoá chúng (404) và màn hình báo "Failed to fetch dynamically
 * imported module". Cách chữa duy nhất là tải lại trang để lấy index mới.
 *
 * Tải lại TỐI ĐA một lần mỗi RELOAD_GUARD_MS: chunk hỏng vì lý do khác (mạng rớt,
 * lỗi build) thì không được kẹt vòng tải lại — lần thứ hai để lỗi hiện ra như cũ.
 */

const RELOAD_KEY = "vucar:chunk-reload-at"
const RELOAD_GUARD_MS = 30_000

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i, // Chromium
  /error loading dynamically imported module/i, // Firefox
  /Importing a module script failed/i, // Safari
  /Unable to preload CSS/i, // Vite preload helper
]

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "")
  return CHUNK_ERROR_PATTERNS.some((re) => re.test(message))
}

let reloading = false

/** Tải lại trang nếu chưa tải lại trong RELOAD_GUARD_MS vừa qua. true = đang tải lại. */
export function reloadForNewBuild(): boolean {
  // Nhiều chunk cùng hỏng trong một lần → mọi caller đều biết trang sắp tải lại.
  if (reloading) return true
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0)
    if (last && Date.now() - last < RELOAD_GUARD_MS) return false
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  } catch {
    // Không ghi được mốc (chế độ riêng tư) thì không tải lại — tránh vòng lặp.
    return false
  }
  reloading = true
  window.location.reload()
  return true
}

/** Bắt lỗi chunk ở mọi đường import động: helper preload của Vite và promise rơi. */
export function installChunkReload(): void {
  // Không preventDefault: để lỗi vẫn tới caller (dynamic() giữ Suspense chờ);
  // nuốt lỗi thì import trả undefined và React báo lỗi khác, khó hiểu hơn.
  window.addEventListener("vite:preloadError", () => {
    reloadForNewBuild()
  })
  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event.reason)) reloadForNewBuild()
  })
}
